import { Grid, Typography } from "@mui/material";
import { settings } from "app";
import { ArrayInput, maxValue, minValue, NumberInput, required, SimpleFormIterator, TextInput } from "react-admin";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import { MembersIteratorItem } from "server/components/Fields/MemberFields";

const ColloquiumForm = () => {
  return (
    <>
      <Typography
        color={"primary"}
        sx={{ textAlign: "center", fontWeight: "bold", margin: "2rem" }}
      >
        Тип на тема: Колоквиум
      </Typography>
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
          md={4}
        >
          <CustomDateInput
            source="attendanceDate"
            label="Дата на присъствие"
            validate={required()}
            noTime
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <NumberInput
            source="grade"
            label="Оценка"
            validate={[required(), minValue(2), maxValue(6)]}
            onWheel={e => e.target.blur()}
          />
        </Grid>
        <Grid
          item
          xs={12}
        >
          <TextInput
            source="questions"
            label="Въпроси"
            sx={settings.style.textAria}
            variant="outlined"
            fullWidth
            multiline
          />
        </Grid>
        <ArrayInput
          source="committeeMembers"
          label="Членове"
          defaultValue={[{}]}
        >
          <SimpleFormIterator
            inline={false}
            sx={settings.style.iteratorWithoutGap}
          >
            <MembersIteratorItem arraySource="committeeMembers" />
          </SimpleFormIterator>
        </ArrayInput>
      </Grid>
    </>
  );
};

export default ColloquiumForm;
